import { render, staticRenderFns } from "./historicalSalesOrder.vue?vue&type=template&id=1ffaf569&scoped=true"
import script from "./historicalSalesOrder.vue?vue&type=script&lang=js"
export * from "./historicalSalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffaf569",
  null
  
)

export default component.exports